<template>
  <v-dialog v-model="changePasswordDialog" class="the-app-dialogs" persistent max-width="500px">
    <v-card>
      <form @submit.prevent="validateBeforeSubmit($event)">
        <v-layout row class="no-select" style="background-color:#09132f">
          <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
            <v-layout align-center>
              <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">
                lock
              </v-icon>
              <span class="px-3">{{ $t('Change Password') }}</span>
            </v-layout>
          </h3>
          <v-spacer />
          <v-card-actions>
            <v-btn fab icon dark @click="$emit('hidemodal')">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-actions>
        </v-layout>

        <v-card-title class="grey lighten-3">
          <v-layout column>
            <v-layout row wrap>
              <v-flex xs12 pa-2>
                <v-text-field
                  id="password-focus-me"
                  v-model="form.old_password"
                  :label="`${$t('Current Password')} *`"
                  name="old_password"
                  :type="showPassword ? 'text' : 'password'"
                  :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                  @click:append="showPassword = !showPassword"
                  background-color="gray"
                  v-validate="'required|min:6'"
                  :error="errors.has('old_password')"
                  box
                  hide-details
                  autocomplete="off"
                  prepend-inner-icon="lock"
                />
              </v-flex>
              <v-flex xs12 pa-2>
                <v-text-field
                  v-model="form.new_password"
                  :label="`${$t('New Password')} *`"
                  name="new_password"
                  :type="showPassword ? 'text' : 'password'"
                  background-color="gray"
                  v-validate="'required|min:6'"
                  :error="errors.has('new_password')"
                  box
                  hide-details
                  autocomplete="off"
                  prepend-inner-icon="lock"
                  ref="password"
                />
              </v-flex>
              <v-flex xs12 pa-2>
                <v-text-field
                  v-model="form.new_password_confirmation"
                  :label="`${$t('Confirm Password')} *`"
                  name="new_password_confirmation"
                  :type="showPassword ? 'text' : 'password'"
                  background-color="gray"
                  v-validate="'required|min:6|confirmed:password'"
                  :error="errors.has('new_password_confirmation')"
                  box
                  hide-details
                  autocomplete="off"
                  prepend-inner-icon="lock"
                />
              </v-flex>
            </v-layout>
          </v-layout>
        </v-card-title>
        <v-divider light />

        <v-card-actions class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="pb-2 px-2" style="color: #444;"
              >- {{ $t('Fields marked with asterisk ( * ) are required.') }}</v-flex
            >
            <v-layout justify-end>
              <v-btn outline color="primary" @click="$emit('hidemodal')">{{ $t('Cancel') }}</v-btn>
              <v-btn type="submit" color="success" :loading="btnAddLoading">
                <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">save</v-icon>
                {{ $t('Change Password') }}
              </v-btn>
            </v-layout>
          </v-layout>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import * as helpers from '@/mixins/helperFunctions.js'

export default {
  name: 'change-password-component',

  props: {
    changePasswordDialog: { type: Boolean, required: true }
  },

  data() {
    return {
      btnAddLoading: false,
      form: {},
      showPassword: false
    }
  },

  computed: {
    ...mapGetters({
      authUserData: 'auth/getAuthUserData'
    })
  },

  watch: {
    changePasswordDialog: {
      immediate: false,
      handler() {
        if (this.changePasswordDialog) {
          this.addEscKeyListener()
          this.$validator.pause()
          for (let key in this.form) {
            this.form[`${key}`] = null
          }
          this.$nextTick(() => {
            this.$validator.resume()
            // default veutify autofocus only one time works so we have to handled in this way.
            // document.getElementById('password-focus-me').focus()
          })
        }
      }
    }
  },

  methods: {
    ...mapActions({
      changePassword: 'staff/changePassword'
    }),

    hasPermissions(permissions) {
      return helpers.userHasPermissions(permissions)
    },

    addEscKeyListener() {
      document.addEventListener('keyup', e => {
        // if the "ESC" button was pressed and this dialog is shown, hide it
        if (e.keyCode === 27 && this.changePasswordDialog) {
          this.$emit('hidemodal')
        }
      })
    },

    validateBeforeSubmit(event) {
      this.$validator.validateAll().then(() => {
        if (!this.errors.any()) {
          this.btnAddLoading = true

          let formData = new FormData(event.target)
          formData.append('lang', this.authUserData.lang)

          let payload = { id: this.authUserData.user_id, formData }
          this.changePassword(payload)
            .then(() => {
              this.form = {}
              this.btnAddLoading = false
              this.$emit('hidemodal')
            })
            .catch(() => {
              this.btnAddLoading = false
            })
        }
      })
    }
  }
}
</script>

<style scoped></style>
